<template>
    <li class="nav-item">
        <a class="nav-link text-capitalize" :class="{ active: this.tabsSettings.activeTab == this.name}" aria-current="page" href="#" 
            @click.prevent="this.tabsSettings.activeTab = this.name">{{prettyName ?? name}}</a>
    </li>
</template>

<script>

export default {
    name: 'Tab',
    emits: ["update:tabsSettings","update:tabs-settings"],
    components: {
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        prettyName: {
            type: String,
            required: false,
            default: null,
        },
        tabsSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        const testData = true;

        return {
            testData,
        };
    },
    methods: {
    },
    computed: {
        testComputed() {
            return true;
        },
    },
    created() {
        // console.log('Component created');
    },
    mounted() {
        // console.log('Component mounted');
    },
    watch: {
    }
};
</script>